import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 103.9 104.2">
    <path
      fill="#fff"
      d="M0 99.5V4.6C0 2.1 2.1 0 4.6 0h94.6c2.6 0 4.6 2.1 4.6 4.6v94.9c0 2.6-2.1 4.6-4.6 4.6H4.6c-2.5.1-4.6-2-4.6-4.6zm64.4-22.7l-.3-1-19.8-51.3c-.3-.7-.6-.9-1.3-.9H32.3c-.8 0-1.1.2-1.4.9L11.1 75.7l-.3 1c3.4 0 6.8.1 10.1 0 1.8 0 3-1.1 3.6-2.8l2.8-8.2c.2-.7.6-1 1.4-1h18.1c.7 0 1.1.2 1.3.9l2.8 8.2c.5 1.6 1.6 2.7 3.3 2.8 3.3.3 6.7.2 10.2.2zM93 87.7v-7H64.4v7H93z"
    />
    <path d="M64.4 76.8c-3.5 0-7 .1-10.4 0-1.7-.1-2.7-1.2-3.3-2.8l-2.8-8.2c-.2-.7-.6-.9-1.3-.9H28.5c-.8 0-1.1.2-1.4 1l-2.8 8.2c-.6 1.7-1.8 2.7-3.6 2.8-3.3.1-6.6 0-10.1 0 .1-.4.2-.7.3-1L31 24.6c.3-.7.6-.9 1.4-.9h10.7c.7 0 1.1.2 1.3.9l19.8 51.3c.1.2.1.5.2.9zM37.7 35.2l-7.2 21.3h14.3l-7.1-21.3zM93 87.7H64.4v-7H93v7z" />
    <path fill="#fff" d="M37.7 35.2l7.1 21.3H30.5l7.2-21.3z" />
  </svg>
);

// const IconLogo = () => (
//   <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
//     <title>Logo</title>
//     <g transform="translate(-8.000000, -2.000000)">
//       <g transform="translate(11.000000, 5.000000)">
//         <polygon
//           id="Shape"
//           stroke="currentColor"
//           strokeWidth="5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           points="39 0 0 22 0 67 39 90 78 68 78 23"
//         />
//         <path
//           d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
//           fill="currentColor"
//         />
//       </g>
//     </g>
//   </svg>
// );

export default IconLogo;
